import ChangePasswordForm from "../Components/Forms/ChangePasswordForm";
import React from "react";

export const ChangePassword = () => {
  return <ChangePasswordForm />;
};
